<template>
  <div id="landing-wrapper" ref="landingWrapper" @scroll="handleScroll">
    <div
      id="header-wrapper"
      :class="
        isScrolled ? 'header-background-blur' : 'header-background-transparent'
      "
    >
      <header>
        <button id="header-logo-wrapper" type="button" @click="scrollToTop">
          <picture>
            <source srcset="../assets/img/logo-MEC.webp" type="image/webp" />
            <source srcset="../assets/img/logo-MEC.png" type="image/png" />
            <img
              src="../assets/img/logo-MEC.png"
              alt="Logo MEC"
              width="49"
              height="27"
            />
          </picture>
        </button>

        <div id="header-btns-container">
          <button
            id="header-login-btn"
            type="button"
            @click="handlePageChange('login')"
          >
            <span>Ingresar</span>
          </button>
          <button
            id="header-register-btn"
            class="grad-color-2"
            type="button"
            @click="handlePageChange('register')"
          >
            <span>Registrarse</span>
          </button>
        </div>
      </header>
    </div>

    <div class="landing-section">
      <div id="landing-hero-section">
        <h1 class="landing-hero-title-container">
          <span class="txt-grad-azul">Digita, </span>
          <span class="txt-grad-color-2">Transforma, </span>
          <span class="txt-grad-color-3">Evoluciona.</span>
        </h1>

        <p class="landing-hero-text">
          MEC es una plataforma para docentes que brinda velocidad y
          confiabilidad gracias a los innovadores modelos matemáticos de
          inteligencia artificial que utiliza para la valoración en la
          educación.
        </p>

        <button
          class="landing-hero-btn"
          type="button"
          @click="handlePageChange('login')"
        >
          <span>Comenzar</span>
        </button>

        <p class="landing-hero-lead">TRANSFORMA TUS VALORACIONES CON IA</p>

        <!-- <iframe
          class="landing-video"
          src="https://www.youtube.com/embed/LyUxsZc5pFk"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe> -->

        <p class="landing-hero-lead">EXPLORA EL proceso</p>
      </div>
    </div>

    <div class="landing-section">
      <div id="landing-first-step-head">
        <div
          class="landing-black-step-nmb-container landing-first-step-grad"
          ref="firstStepCapsule"
        >
          1
        </div>

        <p class="landing-step-label txt-grad-azul">Primer Paso</p>

        <h2 class="landing-first-step-title">Digita tus valoraciones.</h2>

        <p class="landing-first-step-txt">
          Apoyamos al docente en el proceso de evaluación con técnicas de
          <span class="txt-grad-azul txt-bold"
            >valoraciones basadas en la lógica Difusa.</span
          >
        </p>
      </div>
    </div>

    <div class="landing-section">
      <div class="landing-fs-content-wrapper">
        <picture class="landing-fs-content-picture">
          <source
            srcset="
              ../assets/img/imagenes-aplicacion-digitacion-valoraciones.webp
            "
            type="image/webp"
          />
          <source
            srcset="
              ../assets/img/imagenes-aplicacion-digitacion-valoraciones.png
            "
            type="image/png"
          />
          <img
            class="landing-fs-content-image"
            src="../assets/img/imagenes-aplicacion-digitacion-valoraciones.png"
            alt="Pantallas digitación valoraciones"
            loading="lazy"
          />
        </picture>

        <div class="landing-fs-content-txt-wrapper">
          <div class="landing-fs-content-txt-card">
            <div class="landing-fs-content-icon-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                fill="currentColor"
                class="bi bi-gear-wide-connected"
                viewBox="0 0 16 16"
              >
                <path
                  d="M7.068.727c.243-.97 1.62-.97 1.864 0l.071.286a.96.96 0 0 0 1.622.434l.205-.211c.695-.719 1.888-.03 1.613.931l-.08.284a.96.96 0 0 0 1.187 1.187l.283-.081c.96-.275 1.65.918.931 1.613l-.211.205a.96.96 0 0 0 .434 1.622l.286.071c.97.243.97 1.62 0 1.864l-.286.071a.96.96 0 0 0-.434 1.622l.211.205c.719.695.03 1.888-.931 1.613l-.284-.08a.96.96 0 0 0-1.187 1.187l.081.283c.275.96-.918 1.65-1.613.931l-.205-.211a.96.96 0 0 0-1.622.434l-.071.286c-.243.97-1.62.97-1.864 0l-.071-.286a.96.96 0 0 0-1.622-.434l-.205.211c-.695.719-1.888.03-1.613-.931l.08-.284a.96.96 0 0 0-1.186-1.187l-.284.081c-.96.275-1.65-.918-.931-1.613l.211-.205a.96.96 0 0 0-.434-1.622l-.286-.071c-.97-.243-.97-1.62 0-1.864l.286-.071a.96.96 0 0 0 .434-1.622l-.211-.205c-.719-.695-.03-1.888.931-1.613l.284.08a.96.96 0 0 0 1.187-1.186l-.081-.284c-.275-.96.918-1.65 1.613-.931l.205.211a.96.96 0 0 0 1.622-.434l.071-.286zM12.973 8.5H8.25l-2.834 3.779A4.998 4.998 0 0 0 12.973 8.5zm0-1a4.998 4.998 0 0 0-7.557-3.779l2.834 3.78h4.723zM5.048 3.967c-.03.021-.058.043-.087.065l.087-.065zm-.431.355A4.984 4.984 0 0 0 3.002 8c0 1.455.622 2.765 1.615 3.678L7.375 8 4.617 4.322zm.344 7.646.087.065-.087-.065z"
                />
              </svg>
            </div>

            <p class="landing-fs-content-card-title txt-bold">
              Configuración con normatividad
            </p>

            <p class="landing-fs-content-card-txt">
              Nuestro algoritmo matemático está configurado con los rangos y
              valoraciones definido por el Ministerio de Educación Nacional de
              Colombia (MEN).
            </p>
          </div>

          <div class="landing-fs-content-txt-card">
            <div class="landing-fs-content-icon-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                fill="currentColor"
                class="bi bi-pencil-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
                />
              </svg>
            </div>

            <p class="landing-fs-content-card-title txt-bold">
              Digitación Fácil en un solo lugar.
            </p>

            <p class="landing-fs-content-card-txt">
              Nuestra lógica en la interfaz permite digitar de manera sencilla
              cada una de las valoraciones.
            </p>
          </div>

          <div class="landing-fs-content-txt-card">
            <div class="landing-fs-content-icon-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="currentColor"
                class="bi bi-wifi"
                viewBox="0 0 16 16"
              >
                <path
                  d="M15.384 6.115a.485.485 0 0 0-.047-.736A12.444 12.444 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049z"
                />
                <path
                  d="M13.229 8.271a.482.482 0 0 0-.063-.745A9.455 9.455 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065zm-2.183 2.183c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091l.016-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z"
                />
              </svg>
            </div>

            <p class="landing-fs-content-card-title txt-bold">
              Usabilidad en tiempo real.
            </p>

            <p class="landing-fs-content-card-txt">
              Desde el almacenamiento en caché hasta las funciones del servidor,
              nuestra plataforma en la nube funcionan perfectamente.
            </p>
          </div>
        </div>

        <p class="landing-fs-content-subt">
          EL MEJOR ALIADO PARA TUS VALORACIONES
        </p>
      </div>
    </div>

    <div class="landing-section">
      <div class="landing-second-step-head">
        <div
          class="landing-black-step-nmb-container landing-second-step-grad"
          ref="secondStepCapsule"
        >
          2
        </div>

        <p class="landing-step-label txt-grad-color-2">Segundo Paso</p>

        <h2 class="landing-second-step-title">Transforma tus datos.</h2>

        <p class="landing-second-step-txt">
          Somos tu aliado en los procesos de valoraciones. A través de la lógica
          difusa, podemos
          <span class="txt-grad-color-2 txt-bold">
            disminuir la incertidumbre
          </span>
          y la imprecisión en la toma de decisiones.
        </p>
      </div>
    </div>

    <div class="landing-section">
      <div class="landing-ss-content-wrapper">
        <picture class="landing-ss-content-picture">
          <source
            srcset="../assets/img/imagenes-aplicacion-digitacion-celular.webp"
            type="image/webp"
          />
          <source
            srcset="../assets/img/imagenes-aplicacion-digitacion-celular.png"
            type="image/png"
          />
          <img
            class="landing-ss-content-image"
            src="../assets/img/imagenes-aplicacion-digitacion-celular.png"
            alt="Pantallas digitación en celular"
            loading="lazy"
          />
        </picture>

        <div class="landing-ss-content-txt-wrapper">
          <div class="landing-ss-content-txt-card">
            <div class="landing-ss-content-icon-box landing-second-step-grad">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                fill="currentColor"
                class="bi bi-terminal"
                viewBox="0 0 16 16"
              >
                <path
                  d="M6 9a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 9zM3.854 4.146a.5.5 0 1 0-.708.708L4.793 6.5 3.146 8.146a.5.5 0 1 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2z"
                />
                <path
                  d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12z"
                />
              </svg>
            </div>

            <p class="landing-ss-content-card-title">Análisis de datos</p>

            <p class="landing-ss-content-card-txt">
              Nuestro algoritmo activa el proceso de inspección, limpieza,
              transformación y modelado de datos con el objetivo de descubrir
              información útil, apoyar la toma de decisiones y desentrañar
              patrones y tendencias en los datos.
            </p>
          </div>

          <div class="landing-ss-content-txt-card">
            <div class="landing-ss-content-icon-box landing-second-step-grad">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                fill="currentColor"
                class="bi bi-cloud-check"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                />
                <path
                  d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                />
              </svg>
            </div>

            <p class="landing-ss-content-card-title">
              Toma de decisiones con IA
            </p>

            <p class="landing-ss-content-card-txt">
              La IA es capaz de procesar grandes cantidades de datos y
              proporcionar información valiosa que puede utilizarse para tomar
              decisiones informadas. Sin embargo, es importante tener en cuenta
              que la toma de decisiones con IA debe ser un proceso colaborativo
              entre la IA y los seres humanos. En este proceso, la IA
              proporciona información y análisis valiosos considerando tanto la
              información generada por los datos como otros factores relevantes.
            </p>
          </div>
        </div>

        <p class="landing-ss-content-subt">Visualiza tu información</p>
      </div>
    </div>

    <div class="landing-section">
      <div class="landing-third-step-head">
        <div
          class="landing-white-step-nmb-container landing-third-step-grad"
          ref="thirdStepCapsule"
        >
          3
        </div>

        <p class="landing-step-label txt-grad-color-3">Tercer Paso</p>

        <h2 class="landing-third-step-title">Evoluciona en la Evaluación</h2>

        <p class="landing-third-step-txt">
          La evaluación con inteligencia artificial puede ayudar a mejorar la
          <span class="txt-grad-color-3 txt-bold">
            precisión, eficiencia, objetividad y personalización de las
            valoraciones
          </span>
          en una amplia variedad de campos, lo que puede conducir a mejores
          decisiones y resultados.
        </p>
      </div>
    </div>

    <div class="landing-section">
      <div class="landing-ts-content-wrapper">
        <div class="landing-ts-card">
          <p class="landing-ts-card-title txt-bold">Resultado Final</p>

          <p class="landing-ts-card-subtitle">
            Su valoración es
            <span class="txt-bold txt-accent" ref="notaLandingSpan">{{
              notaLanding
            }}</span>
            en un rango
            <span class="txt-bold txt-accent">MEDIO</span>
          </p>

          <div class="landing-ts-chart-wrapper">
            <RadarChart
              :dataProp="[5, 3.5, 5, 4, 5]"
              :labelsProp="[
                'Momento 1',
                'Momento 2',
                'Momento 3',
                'Momento 4',
                'Momento 5',
              ]"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="landing-section">
      <div class="landing-ls-content-wrapper">
        <h4 class="landing-ls-title">
          Bienvenido a nuestra
          <span class="landing-ls-title-ia txt-grad-color-2"
            >Inteligencia Artificial</span
          >
        </h4>

        <button
          class="landing-hero-btn"
          type="button"
          @click="handlePageChange('login')"
        >
          <span>Comenzar</span>
        </button>
      </div>
    </div>

    <footer class="landing-section">
      <p class="landing-copyright-txt">
        Copyright &copy; {{ new Date().getFullYear() }}
        <a
          class="txt-grad-color-2"
          href="https://www.aprocom.com.co/"
          target="_blank"
          >APROCOM SIGLO XXI S.A.S</a
        >
        Todos los derechos reservados.
      </p>
    </footer>
    <!-- <div class="container">
      <img src="../assets/img/banner_mec2.png" style="width: 100%" alt="" />
      <br />
      <br />
      <table class="table">
        <thead class="thead-dark">
          <tr>
            <th>NOTA PARA:</th>
            <th>NOTA</th>
            <th>PESO</th>
            <th></th>
            <th>CALIFICACI&Oacute;N TRADICIONAL</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Seguimiento</strong></td>
            <td>
              <div id="lblDispNotaSeg" align="center">0.0</div>
              <input
                type="range"
                class="form-control-range"
                id="rgNotaSeg"
                @change="OnchangeRange('rgNotaSeg', 'lblDispNotaSeg')"
                @input="OnchangeRange('rgNotaSeg', 'lblDispNotaSeg')"
                min="0"
                max="5"
                step="0.1"
              />
            </td>

            <td>
              <div id="lblDispPesoSeg" align="center">0.0</div>
              <input
                type="range"
                class="form-control-range"
                id="rgPesoSeg"
                @change="OnchangeRange('rgPesoSeg', 'lblDispPesoSeg', '%')"
                @input="OnchangeRange('rgPesoSeg', 'lblDispPesoSeg', '%')"
                min="0"
                max="100"
                step="1"
              />
            </td>
            <td></td>
            <td><div align="center" id="lbNotaFinalSeguimiento">0.0</div></td>
          </tr>
          <tr>
            <td><strong>Evaluaciones</strong></td>
            <td>
              <div id="lblDispNotaEval" align="center">0.0</div>
              <input
                type="range"
                class="form-control-range"
                id="rgNotaEval"
                @change="OnchangeRange('rgNotaEval', 'lblDispNotaEval')"
                @input="OnchangeRange('rgNotaEval', 'lblDispNotaEval')"
                min="0"
                max="5"
                step="0.1"
              />
            </td>
            <td>
              <div id="lblDispPesoEval" align="center">0.0</div>
              <input
                type="range"
                class="form-control-range"
                id="rgPesoEval"
                @change="OnchangeRange('rgPesoEval', 'lblDispPesoEval', '%')"
                @input="OnchangeRange('rgPesoEval', 'lblDispPesoEval', '%')"
                min="0"
                max="100"
                step="1"
              />
            </td>
            <td></td>
            <td><div align="center" id="lbNotaFinalEvaluaciones">0.0</div></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td><div align="center" id="lbSumatoria">0.0</div></td>
          </tr>
        </tbody>
      </table>
      <div align="center">
        <button
          class="btn btn-primary"
          id="btnCalcular"
          @click="updatecalcCompetencias()"
        >
          CALCULAR
        </button>
      </div>
      <br />
      <p>
        <strong>NOTA POR COMPETENCIAS: </strong>
        <span id="lblNotaCompetencias"></span>
      </p>
      <p align="right">
        <img src="../assets/img/logos.png" style="width: 40%" alt="" />
      </p>
    </div> -->
  </div>
</template>

<script>
import RadarChart from "@/components/Charts/RadarChart.vue";

export default {
  components: { RadarChart },

  data() {
    return {
      scrollPosition: 0,
      notaLanding: 3.9,
    };
  },

  computed: {
    isScrolled() {
      return this.scrollPosition > 64;
    },
  },

  mounted() {
    // this.$refs.landingWrapper.addEventListener("scroll", this.handleScroll);
    // // window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    // OnchangeRange(rangeId, lbldisp, comp) {
    //   var lbldispObj = this.$jQuery("#" + lbldisp);
    //   var rangeIdObj = this.$jQuery("#" + rangeId);

    //   lbldispObj.html(rangeIdObj.val() + (comp ? comp : ""));
    //   this.updateCalcNormal();
    // },
    // initInputs() {
    //   this.OnchangeRange("rgNotaSeg", "lblDispNotaSeg");
    //   this.OnchangeRange("rgPesoSeg", "lblDispPesoSeg", "%");

    //   this.OnchangeRange("rgNotaEval", "lblDispNotaEval");
    //   this.OnchangeRange("rgPesoEval", "lblDispPesoEval", "%");
    // },
    // round(num) {
    //   return Math.round(num * 100) / 100;
    // },

    // updatecalcCompetencias() {
    //   var rgNotaSeg = this.$jQuery("#rgNotaSeg");
    //   var rgPesoSeg = this.$jQuery("#rgPesoSeg");

    //   var rgNotaEval = this.$jQuery("#rgNotaEval");
    //   var rgPesoEval = this.$jQuery("#rgPesoEval");

    //   var lblNotaCompetencias = this.$jQuery("#lblNotaCompetencias");

    //   this.$jQuery.post(
    //     "http://localhost:3000/MEC_API/getNotaComp",
    //     {
    //       notaSeg: rgNotaSeg.val(),
    //       pesoSeg: rgPesoSeg.val(),
    //       notaEval: rgNotaEval.val(),
    //       pesoEval: rgPesoEval.val(),
    //     },
    //     function (data) {
    //       if (data.err) {
    //         console.log(data.err);
    //         lblNotaCompetencias.html("0.0");
    //       } else {
    //         lblNotaCompetencias.html(data.result[0].RESPUESTA);
    //       }
    //     }
    //   );
    // },
    // updateCalcNormal() {
    //   var rgNotaSeg = this.$jQuery("#rgNotaSeg");
    //   var rgPesoSeg = this.$jQuery("#rgPesoSeg");

    //   var rgNotaEval = this.$jQuery("#rgNotaEval");
    //   var rgPesoEval = this.$jQuery("#rgPesoEval");

    //   var lbNotaFinalSeguimiento = this.$jQuery("#lbNotaFinalSeguimiento");
    //   var lbNotaFinalEvaluaciones = this.$jQuery("#lbNotaFinalEvaluaciones");

    //   var lbSumatoria = this.$jQuery("#lbSumatoria");

    //   var notaFSeg = this.round(
    //     parseFloat(rgNotaSeg.val()) * (parseFloat(rgPesoSeg.val()) / 100)
    //   );
    //   var notaFEval = this.round(
    //     parseFloat(rgNotaEval.val()) * (parseFloat(rgPesoEval.val()) / 100)
    //   );

    //   lbNotaFinalSeguimiento.html(notaFSeg);
    //   lbNotaFinalEvaluaciones.html(notaFEval);

    //   lbSumatoria.html(this.round(notaFSeg + notaFEval));
    // },

    handlePageChange(page) {
      this.$emit("pageChange", { page, lastPage: "landing" });
    },

    handleScroll(event) {
      this.scrollPosition = event.target.scrollTop;
      const firstStepCapsuleInfo =
        this.$refs.firstStepCapsule.getBoundingClientRect();
      const secondStepCapsuleInfo =
        this.$refs.secondStepCapsule.getBoundingClientRect();
      const thirdStepCapsuleInfo =
        this.$refs.thirdStepCapsule.getBoundingClientRect();
      // const notaLandingSpanInfo =
      //   this.$refs.notaLandingSpan.getBoundingClientRect();

      if (
        firstStepCapsuleInfo.top + window.innerHeight / 2 <
          window.innerHeight &&
        firstStepCapsuleInfo.bottom >= 0
      ) {
        // console.log(firstStepCapsuleInfo);
        this.$refs.firstStepCapsule.style.height = `${150}px`;
      } else {
        this.$refs.firstStepCapsule.style.height = "95px";
      }

      if (
        secondStepCapsuleInfo.top + window.innerHeight / 2 <
          window.innerHeight &&
        secondStepCapsuleInfo.bottom >= 0
      ) {
        // console.log(secondStepCapsuleInfo);
        this.$refs.secondStepCapsule.style.height = `${150}px`;
      } else {
        this.$refs.secondStepCapsule.style.height = "95px";
      }

      if (
        thirdStepCapsuleInfo.top + window.innerHeight / 2 <
          window.innerHeight &&
        thirdStepCapsuleInfo.bottom >= 0
      ) {
        // console.log(thirdStepCapsuleInfo);
        this.$refs.thirdStepCapsule.style.height = `${150}px`;
      } else {
        this.$refs.thirdStepCapsule.style.height = "95px";
      }

      // if (
      //   notaLandingSpanInfo.top + window.innerHeight / 2 < window.innerHeight &&
      //   notaLandingSpanInfo.bottom >= 0
      // ) {
      //   this.notaLanding = 3.9;
      // } else {
      //   this.notaLanding = 0.0;
      // }
    },

    scrollToTop() {
      this.$refs.landingWrapper.scroll({ top: 0, left: 0, behavior: "smooth" });
    },
  },
};
</script>

<style>
/* ---------------------------------------------- Elementos reutilizables */
.landing-section {
  width: 100%;
  max-width: 1248px;
  padding: 0 24px;
  margin: 0 auto;
}

.landing-white-step-nmb-container {
  padding: 10px 0;
  width: 40px;
  height: 95px;
  color: var(--white);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 30px;
  font-weight: 700;
  border-radius: 40px;
  transition: height 0.25s ease-in-out;
}

.landing-black-step-nmb-container {
  padding: 10px 0;
  width: 40px;
  height: 95px;
  color: var(--black);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 30px;
  font-weight: 700;
  border-radius: 40px;
  transition: height 0.25s ease-in-out;
}

.landing-step-label {
  font-size: 32px;
  font-weight: 700;
  text-align: center;
}

@media screen and (max-width: 720px) {
  .landing-step-label {
    font-size: 20px;
  }
}

/* ---------------------------------------------- Contenedor Landing */
#landing-wrapper {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  background-color: var(--black);
  /* scroll-behavior: smooth; */
}

#landing-wrapper *::selection {
  background-color: var(--white);
  color: var(--black);
}

/* ---------------------------------------------- Landing Header */
#header-wrapper {
  width: 100%;
  height: 64px;
  position: sticky;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  transition: box-shadow 0.3s ease-in-out, background 0.3s linear;
}

.header-background-transparent {
  background-color: transparent;
}

.header-background-blur {
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: saturate(180%) blur(5px);
  box-shadow: inset 0 -1px 0 0 hsla(0, 0%, 100%, 0.1);
}

#header-wrapper header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1248px;
  padding: 0 24px;
  margin: auto;
}

#header-logo-wrapper {
  all: unset;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}

#header-logo-wrapper:focus {
  transform: scale(1.1);
}

#header-btns-container {
  display: flex;
  gap: 1.5rem;
}

#header-login-btn {
  all: unset;
  padding: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

#header-login-btn span {
  color: var(--white);
  transition: color 0.3s linear;
  padding: 5px 20px;
}

#header-login-btn:hover span {
  color: var(--hover-white);
}

#header-login-btn:focus {
  outline: 1px solid #fff;
  outline-offset: 2px;
}

#header-register-btn {
  all: unset;
  padding: 1.5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: var(--grad-color-2);
  border-radius: 5px;
}

#header-register-btn span {
  width: 100%;
  height: 100%;
  padding: 5px 20px;
  border-radius: 3px;
  font-weight: 700;
  background-color: transparent;
  transition: background 0.3s ease-in-out, color 0.3s linear;
}

#header-register-btn:hover span {
  background-color: var(--black);
  color: #fff;
}

#header-register-btn:focus {
  outline: 1px solid #fff;
  outline-offset: 4px;
}

@media screen and (max-width: 720px) {
  #header-btns-container {
    gap: 0.5rem;
  }

  #header-login-btn span {
    padding: 5px 15px;
    font-size: 14px;
  }

  #header-register-btn span {
    padding: 5px 15px;
    font-size: 14px;
  }
}

/* ---------------------------------------------- Primera seccion landing */
#landing-hero-section {
  width: 100%;
  min-height: 100vh;
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 0;
}

.landing-hero-title-container {
  margin: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 70px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  user-select: none;
}

.landing-hero-title-container span {
  padding: 2px 0;
}

.landing-hero-text {
  margin: 20px auto 38px;
  width: 90%;
  max-width: 780px;
  text-align: center;
  color: var(--white);
  font-size: 20px;
}

.landing-hero-btn {
  all: unset;
  margin: 0 auto 30px;
  padding: 1.5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--grad-color-2);
  border-radius: 15px;
}

.landing-hero-btn span {
  font-size: 16px;
  font-weight: 800;
  padding: 10px 30px;
  border-radius: 13px;
  background-color: var(--black);
  color: var(--white);
  transition: background 0.3s ease-in-out;
}

.landing-hero-btn:hover span {
  background-color: transparent;
}

.landing-hero-lead {
  margin: 40px auto;
  font-size: 12px;
  color: var(--white);
  letter-spacing: 3.2px;
  text-transform: uppercase;
  text-align: center;
}

.landing-video {
  width: 90%;
  max-width: 510px;
  aspect-ratio: 16 / 9;
}

@media screen and (max-width: 720px) {
  .landing-hero-title-container {
    font-size: 50px;
  }

  .landing-hero-text {
    font-size: 16px;
  }

  .landing-hero-btn span {
    font-size: 14px;
  }

  .landing-hero-lead {
    font-size: 10px;
  }
}

/* ---------------------------------------------- Landing Primer paso header */
.landing-first-step-grad {
  background-image: var(--grad-color-azul);
}

#landing-first-step-head {
  width: 100%;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.landing-first-step-title {
  font-size: 60px;
  font-weight: 700;
  color: #d9d9d9;
  text-align: center;
}

.landing-first-step-txt {
  width: 90%;
  max-width: 600px;
  font-size: 20px;
  color: var(--white);
  text-align: center;
}

@media screen and (max-width: 720px) {
  #landing-first-step-head {
    padding-bottom: 50px;
  }

  .landing-first-step-title {
    font-size: 40px;
  }

  .landing-first-step-txt {
    font-size: 16px;
  }
}

/* ---------------------------------------------- Landing contenido primer paso */
.landing-fs-content-wrapper {
  width: 100%;
  padding-bottom: 100px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, auto));
  justify-items: center;
  align-items: center;
  grid-template-areas:
    "image txt"
    "subt subt";
}

.landing-fs-content-picture {
  grid-area: image;
}

.landing-fs-content-image {
  width: 100%;
  max-width: 460px;
}

.landing-fs-content-txt-wrapper {
  grid-area: txt;
  padding: 0 40px 40px 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 70px;
}

.landing-fs-content-txt-card {
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.landing-fs-content-icon-box {
  width: 40px;
  height: 40px;
  border: 1px solid var(--white);
  border-radius: 8px;
  background-image: var(--grad-color-azul);
  color: var(--black);
  display: grid;
  place-content: center;
}

.landing-fs-content-card-title {
  margin: 5px 0 0 0;
  padding: 0;
  color: var(--white);
  font-size: 22px;
}

.landing-fs-content-card-txt {
  margin: 0;
  padding: 0;
  color: var(--white);
  font-size: 16px;
}

.landing-fs-content-subt {
  grid-area: subt;
  margin: 50px 0 0 0;
  font-size: 12px;
  color: var(--white);
  letter-spacing: 3.2px;
  text-transform: uppercase;
  text-align: center;
}

@media screen and (max-width: 720px) {
  .landing-fs-content-wrapper {
    padding-bottom: 100px;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: repeat(3, minmax(0, auto));
    grid-template-areas:
      "image"
      "txt"
      "subt ";
  }

  .landing-fs-content-picture {
    padding: 40px 20px;
    display: flex;
    justify-content: center;
  }

  .landing-fs-content-image {
    width: 80%;
  }

  .landing-fs-content-txt-wrapper {
    padding: 0;
    width: 100%;
    align-items: center;
  }

  .landing-fs-content-txt-card:nth-child(1n + 2) {
    display: none;
  }

  .landing-fs-content-txt-card {
    align-items: center;
    width: 100%;
  }

  .landing-fs-content-card-title {
    text-align: center;
    font-size: 16px;
  }

  .landing-fs-content-card-txt {
    text-align: center;
    font-size: 12px;
  }

  .landing-fs-content-subt {
    font-size: 10px;
  }
}

/* ---------------------------------------------- Landing Segundo paso header */
.landing-second-step-grad {
  background-image: var(--grad-color-2);
}

.landing-second-step-head {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.landing-second-step-title {
  width: 90%;
  max-width: 540px;
  margin-top: 50px;
  font-size: 60px;
  font-weight: 700;
  color: #d9d9d9;
  text-align: center;
}

.landing-second-step-txt {
  width: 80%;
  max-width: 600px;
  font-size: 20px;
  color: var(--white);
  text-align: center;
}

@media screen and (max-width: 720px) {
  .landing-second-step-title {
    font-size: 40px;
  }

  .landing-second-step-txt {
    font-size: 16px;
  }
}

/* ---------------------------------------------- Landing contenido segundo paso */
.landing-ss-content-wrapper {
  width: 100%;
  padding: 20px 0 100px 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, auto));
  justify-items: center;
  align-items: center;
  grid-template-areas:
    "image txt"
    "subt subt";
}

.landing-ss-content-picture {
  grid-area: image;
}

.landing-ss-content-image {
  width: 100%;
  max-width: 280px;
}

.landing-ss-content-txt-wrapper {
  grid-area: txt;
  padding: 0 40px 40px 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 80px;
}

.landing-ss-content-txt-card {
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.landing-ss-content-icon-box {
  width: 40px;
  height: 40px;
  border: 1px solid var(--white);
  border-radius: 8px;
  color: var(--black);
  display: grid;
  place-content: center;
}

.landing-ss-content-card-title {
  margin: 5px 0 0 0;
  padding: 0;
  color: var(--white);
  font-size: 22px;
}

.landing-ss-content-card-txt {
  margin: 0;
  padding: 0;
  color: var(--white);
  font-size: 16px;
}

.landing-ss-content-subt {
  grid-area: subt;
  margin: 70px 0 0 0;
  font-size: 12px;
  color: var(--white);
  letter-spacing: 3.2px;
  text-transform: uppercase;
  text-align: center;
}

@media screen and (max-width: 720px) {
  .landing-ss-content-wrapper {
    width: 100%;
    padding: 20px 0 100px 0;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: repeat(3, minmax(0, auto));
    grid-template-areas:
      "image"
      "txt"
      "subt";
  }

  .landing-ss-content-picture {
    display: flex;
    justify-content: center;
    padding: 2.5rem 0;
  }

  .landing-ss-content-image {
    width: 60%;
  }

  .landing-ss-content-txt-wrapper {
    padding: 0;
  }

  .landing-ss-content-txt-card:nth-child(1n + 2) {
    display: none;
  }

  .landing-ss-content-txt-card {
    align-items: center;
    width: 100%;
  }

  .landing-ss-content-card-title {
    text-align: center;
    font-size: 16px;
  }

  .landing-ss-content-card-txt {
    text-align: center;
    font-size: 12px;
  }

  .landing-ss-content-subt {
    font-size: 10px;
  }
}

/* ---------------------------------------------- Landing Tercer paso header */
.landing-third-step-grad {
  background-image: var(--grad-color-3);
}

.landing-third-step-head {
  width: 100%;
  padding-bottom: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.landing-third-step-title {
  width: 90%;
  max-width: 540px;
  margin-top: 50px;
  font-size: 60px;
  font-weight: 700;
  color: #d9d9d9;
  text-align: center;
}

.landing-third-step-txt {
  width: 80%;
  max-width: 600px;
  font-size: 20px;
  color: var(--white);
  text-align: center;
}

@media screen and (max-width: 720px) {
  .landing-third-step-head {
    padding-bottom: 70px;
  }

  .landing-third-step-title {
    font-size: 40px;
  }

  .landing-third-step-txt {
    font-size: 16px;
  }
}

/* ---------------------------------------------- Landing contenido tercer paso */
.landing-ts-content-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 100px;
}

.landing-ts-card {
  width: 90%;
  padding: 40px 0;
  border-radius: 30px;
  border: 1px solid var(--black);
  background-color: rgba(5, 13, 82, 0.2);
  box-shadow: 0px 0px 8px 8px rgba(32, 43, 134, 0.25);
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
  justify-content: center;
}

.landing-ts-card-title {
  margin: 0;
  font-size: 30px;
  text-align: center;
  color: var(--white);
}

.landing-ts-card-subtitle {
  font-size: 20px;
  text-align: center;
  color: var(--white);
}

.landing-ts-chart-wrapper {
  width: 70%;
  min-height: 500px;
  padding: 40px;
  border: 1px solid #c1c1c1;
  border-radius: 15px;
  box-shadow: 0px 0px 8px 8px rgba(146, 146, 146, 0.25);
  background: rgba(5, 13, 82, 0.2);
}

@media screen and (max-width: 720px) {
  .landing-ts-card {
    gap: 30px;
  }

  .landing-ts-card-title {
    font-size: 20px;
  }

  .landing-ts-card-subtitle {
    font-size: 16px;
  }

  .landing-ts-chart-wrapper {
    width: 90%;
    min-height: 300px;
  }
}

/* ---------------------------------------------- Landing contenido tercer paso */
.landing-ls-content-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  padding-bottom: 180px;
}

.landing-ls-title {
  text-align: center;
  font-size: 30px;
  color: var(--white);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.landing-ls-title-ia {
  font-family: var(--special-font);
  margin-top: -4px;
}

@media screen and (max-width: 720px) {
  .landing-ls-content-wrapper {
    padding-bottom: 90px;
  }
}

.landing-copyright-txt {
  font-size: 12px;
  color: var(--white);
  text-align: center;
}
</style>
